document.addEventListener('DOMContentLoaded', () => {
    const accordion = document.querySelectorAll('.accordion');

    if (!accordion) return;

    const initializeAccordion = () => {
        accordion.forEach((elem) => {
            const accordionTitle = elem.querySelector('.accordion__title');
            accordionTitle.addEventListener('click', () => {
                accordionTitle.parentElement.classList.toggle('-open');
                const accordionBody = accordionTitle.nextElementSibling;
                if (accordionBody.style.maxHeight) {
                    accordionBody.style.maxHeight = null;
                } else {
                    accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
                }

                const parentAccordionBody = accordionTitle.closest('.accordion__body');
                if (parentAccordionBody) {
                    parentAccordionBody.style.maxHeight = accordionBody.scrollHeight + parentAccordionBody.scrollHeight + "px";
                }
            });
        });
    };

    const setAccordionBodyHeight = () => {
        accordion.forEach((elem) => {
            if (elem.classList.contains('-open')) {
                const accordionTitle = elem.querySelector('.accordion__title');
                const accordionBody = accordionTitle.nextElementSibling;
                accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";

                const parentAccordionBody = accordionTitle.closest('.accordion__body');
                if (parentAccordionBody) {
                    parentAccordionBody.style.maxHeight = accordionBody.scrollHeight + parentAccordionBody.scrollHeight + "px";
                }
            }
        });
    };

    initializeAccordion();
    window.addEventListener('resize', setAccordionBodyHeight);
});